import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../components/base/Button';

const LanguagePage: React.FC = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const selectLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    document.dir = lang === 'ar' ? 'rtl' : 'ltr';
    navigate('/auth/login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 flex items-center justify-center px-6">
      <div className="bg-white rounded-2xl p-8 w-full max-w-sm shadow-2xl">
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto bg-blue-600 rounded-full flex items-center justify-center mb-4">
            <span className="text-2xl font-bold text-white" style={{ fontFamily: 'Pacifico, serif' }}>
              فَنَار
            </span>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">اختر اللغة</h2>
          <p className="text-gray-600">Select Language</p>
        </div>

        <div className="space-y-4">
          <Button
            onClick={() => selectLanguage('ar')}
            className="w-full text-lg"
            size="lg"
          >
            <span className="mr-3">🇸🇦</span>
            العربية
          </Button>
          
          <Button
            onClick={() => selectLanguage('en')}
            variant="outline"
            className="w-full text-lg"
            size="lg"
          >
            <span className="mr-3">🇺🇸</span>
            English
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LanguagePage;